var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	4544: () => (loadSingletonVersionCheckFallback("default", "rxjs", [4,7,8,0], () => (Promise.all([__webpack_require__.e(4376), __webpack_require__.e(7141), __webpack_require__.e(1340)]).then(() => (() => (__webpack_require__(1340))))))),
	1125: () => (loadSingletonVersionCheckFallback("default", "@angular/core", [4,17,0,3], () => (Promise.all([__webpack_require__.e(4544), __webpack_require__.e(4084), __webpack_require__.e(7404)]).then(() => (() => (__webpack_require__(7404))))))),
	4084: () => (loadSingletonVersionCheckFallback("default", "rxjs/operators", [4,7,8,0], () => (Promise.all([__webpack_require__.e(4376), __webpack_require__.e(7141), __webpack_require__.e(3620)]).then(() => (() => (__webpack_require__(3620))))))),
	1163: () => (loadSingletonVersionCheckFallback("default", "@angular/common", [4,17,0,3], () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(316))))))),
	4223: () => (loadSingletonVersionCheckFallback("default", "@angular/common/http", [4,17,0,3], () => (Promise.all([__webpack_require__.e(4544), __webpack_require__.e(4084), __webpack_require__.e(1163), __webpack_require__.e(6443)]).then(() => (() => (__webpack_require__(6443))))))),
	4271: () => (loadSingletonVersionCheckFallback("default", "@angular/router", [4,17,0,3], () => (Promise.all([__webpack_require__.e(436), __webpack_require__.e(5072)]).then(() => (() => (__webpack_require__(5072))))))),
	1752: () => (loadSingletonVersionCheckFallback("default", "@dat/db", [4,0,0,1], () => (Promise.all([__webpack_require__.e(4544), __webpack_require__.e(4084), __webpack_require__.e(6854)]).then(() => (() => (__webpack_require__(6854))))))),
	7460: () => (loadSingletonVersionCheckFallback("default", "@dat/datiq-core/models", [4,0,0,1], () => (Promise.all([__webpack_require__.e(6227), __webpack_require__.e(4735), __webpack_require__.e(553), __webpack_require__.e(1752), __webpack_require__.e(1738), __webpack_require__.e(4946)]).then(() => (() => (__webpack_require__(4946))))))),
	17: () => (loadSingletonVersionCheckFallback("default", "apollo-angular", [1,4,2,1], () => (Promise.all([__webpack_require__.e(4084), __webpack_require__.e(2920), __webpack_require__.e(9670)]).then(() => (() => (__webpack_require__(9670))))))),
	4937: () => (loadSingletonVersionCheckFallback("default", "@ngrx/store", [2,17,0,0], () => (Promise.all([__webpack_require__.e(2780), __webpack_require__.e(1383)]).then(() => (() => (__webpack_require__(1383))))))),
	1590: () => (loadSingletonVersionCheckFallback("default", "@dat/datiq-graphql", [4,0,0,1], () => (Promise.all([__webpack_require__.e(2920), __webpack_require__.e(677)]).then(() => (() => (__webpack_require__(677))))))),
	5914: () => (loadSingletonVersionCheckFallback("default", "@dat/datiq-rules", [4,0,0,1], () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(5123))))))),
	8122: () => (loadSingletonVersionCheckFallback("default", "@ngrx/effects", [4,17,0,1], () => (__webpack_require__.e(6135).then(() => (() => (__webpack_require__(6135))))))),
	8297: () => (loadSingletonVersionCheckFallback("default", "@angular/forms", [4,17,0,3], () => (__webpack_require__.e(4456).then(() => (() => (__webpack_require__(4456))))))),
	468: () => (loadSingletonVersionCheckFallback("default", "@dat/angular-auth", [1,8,1,0], () => (__webpack_require__.e(4055).then(() => (() => (__webpack_require__(4055))))))),
	3742: () => (loadSingletonVersionCheckFallback("default", "ramda", [2,0,30,1], () => (__webpack_require__.e(6012).then(() => (() => (__webpack_require__(6012))))))),
	2708: () => (loadSingletonFallback("default", "@dat/datiq-observability", () => (__webpack_require__.e(8940).then(() => (() => (__webpack_require__(8940))))))),
	2780: () => (loadSingletonVersionCheckFallback("default", "@angular/core/rxjs-interop", [4,18,0,5], () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(9074)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"17": [
		17
	],
	"1125": [
		1125
	],
	"1163": [
		1163
	],
	"1720": [
		8297
	],
	"1752": [
		1752
	],
	"2708": [
		2708
	],
	"2780": [
		2780
	],
	"4084": [
		4084
	],
	"4223": [
		4223
	],
	"4271": [
		4271
	],
	"4544": [
		4544
	],
	"4937": [
		4937
	],
	"5669": [
		1590,
		5914,
		8122
	],
	"7245": [
		468,
		3742
	],
	"7460": [
		7460
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}